// extracted by mini-css-extract-plugin
module.exports = {"meet_and_greet":"meet_and_greet-1Csia"};